/**
 * On property pause
 * @param {PropertyValueProps | TimelineMapProps} property
 * @param {Boolean} enter
 */
const onPause = (property, enter) => {
  if (enter) {
    property.set("enter-percents", 1);
    property.set("enter-overall", 1);
  } else {
    property.set("leave-percents", 1);
    property.set("leave-overall", 1);
  }
}

export default onPause;